import { render, staticRenderFns } from "./seckill.vue?vue&type=template&id=36192574&scoped=true&"
import script from "./seckill.vue?vue&type=script&lang=js&"
export * from "./seckill.vue?vue&type=script&lang=js&"
import style0 from "./seckill.vue?vue&type=style&index=0&id=36192574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36192574",
  null
  
)

export default component.exports